import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import dialogPolyfill from 'dialog-polyfill';
import '../style/dialog-polyfill.scss';

export class Dialog extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            modal: true
        };

        this.onCancel = this.onCancel.bind(this);
        this.open = this.open.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    componentDidMount() {
        process.env.NODE_ENV !== 'test' && dialogPolyfill.registerDialog(this.dialog);
        if(this.props.isOpen){
            this.open();
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.isOpen && !prevProps.isOpen){
            this.open();
        }else if(!this.props.isOpen && prevProps.isOpen){
            this.close();
        }
    }

    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.isOpen) {
    //         this.open();
    //     }else if(nextProps.isOpen === false){
    //         this.close()
    //     }
    // }

    open() {
        if (!this.dialog.attributes.open) {
            if (this.dialog.showModal) {
                this.dialog.showModal();
                this.dialog.addEventListener('close', this.onCancel);
            }
        }
    }
    close() {
        if(this.dialog.attributes.open){
            this.dialog.close();
        }
        this.dialog.removeEventListener('close', this.onCancel);
        if (this.props.onClose) {
            this.props.onClose();
        }

    }

    cancel() {
        this.onCancel();
        if (this.props.cancel) {
            this.props.cancel();
        }
    }

    onCancel() {
        if(this.dialog.attributes.open) {
            this.dialog.close();
        }
        this.dialog.removeEventListener('close', this.onCancel);
        if(this.props.onClose){
            this.props.onClose();
        }
    }

    render() {
        const className = this.props.className ? this.props.className : "default-dialog";
        const { title, onClose, cancel, canCancel, isOpen, ...rest} = this.props;
        const titleElement = canCancel === true ?
            (<div className="dialog-title">
              <h1 className="ellipsis">{title}</h1>
              <span className="icon-dialog-close" onClick={() => this.close()}/>
            </div>) :
            (<div className="dialog-title">
              <h1 className="ellipsis">{title}</h1>
            </div>);

        return (
            <div>
                <dialog className={className} ref={dialog => (this.dialog = dialog ? dialog : this.dialog)} >
                    {titleElement}
                    {React.cloneElement(this.props.children, {...rest, visible: isOpen})}
                </dialog>
            </div>
        );
    }
}

Dialog.propTypes = {
    children: PropTypes.element,
    title: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    cancel: PropTypes.func,
    canCancel: PropTypes.bool,
    isOpen: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/common/components/dialog.jsx